import { createTheme, ThemeOptions } from "@mui/material";
import {
  MuiButton,
  MuiCheckbox,
  MuiCssBaseline,
  MuiPaper,
  MuiRadio,
  MuiTab,
  MuiTableCell,
  MuiTableHead,
  MuiLink,
  MuiTableRow,
  MuiTabs,
  MuiTooltip,
} from "./components";

export const createFoundationTheme = (themeOptions: ThemeOptions) => {
  // Step 1: Create the theme
  const theme = createTheme(themeOptions);

  // Step 2: use the theme to populate overrides
  return createTheme(theme, {
    components: {
      ...MuiCssBaseline(theme),
      ...MuiCheckbox(),
      ...MuiButton(theme),
      ...MuiPaper(),
      ...MuiRadio(),
      ...MuiTableHead(theme),
      ...MuiTableRow(theme),
      ...MuiTableCell(theme),
      ...MuiTab(),
      ...MuiTabs(),
      ...MuiLink(theme),
      ...MuiTooltip(theme),
    },
  });
};
